import { Box } from '@mui/material'
import { useLocation } from 'react-router'
import { Paths } from '../../../routes'
import { useScrollContext } from '../../../state/scrollState/scrollContext'
import { HomeTabs } from './slide/footer/HomeTabs'

export function CarouselFooter() {
    const { pathname } = useLocation()
    const { atTop } = useScrollContext()
    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: '0px',
                width: '100%',
                zIndex: 100,
                transition: 'opacity 0.2s',
                opacity: atTop && pathname === Paths.home ? 1 : 0,
                pointerEvents:
                    atTop && pathname === Paths.home ? 'auto' : 'none',
            }}
        >
            <HomeTabs />
        </Box>
    )
}
